import React, { PureComponent, Fragment } from 'react';
import PropTypes from 'prop-types';
import errorBoundary from '@ifeng/errorBoundary';
import styles from './index.css';

class Sankey extends PureComponent {
    static propTypes = {
        docData: PropTypes.object,
    };

    sankey = null;

    async componentDidMount() {
        // 引入 ECharts 主模块
        this.echarts = await import('echarts/lib/echarts');

        // 引入桑基图
        await import('echarts/lib/chart/sankey');
        // 引入提示框和标题组件
        await import('echarts/lib/component/tooltip');

        this.sankey = this.echarts.init(document.getElementById('echarts_sankey'));

        const { docData } = this.props;
        const { code, data } = docData;

        if (code !== 0) {
            return;
        }

        const { dataMap } = data;
        const sdMap = new Map();
        const sd = [];
        const links = [];

        Object.entries(dataMap).forEach(([key, outMap]) => {
            const inKey = `in_${key}`;
            let inValue = sdMap.get(inKey) ? sdMap.get(inKey).value : 0;

            Object.entries(outMap).forEach(([key, value]) => {
                if (key !== '未明确') {
                    const outKey = `out_${key}`;
                    const outValue = (sdMap.get(outKey) ? sdMap.get(outKey).value : 0) + value;

                    sdMap.set(outKey, { text: key, value: outValue, type: 'out' });
                    links.push({
                        source: outKey,
                        target: inKey,
                        value,
                    });

                    inValue += value;
                }
            });

            if (inValue) {
                sdMap.set(inKey, { text: key, value: inValue, type: 'in', label: { position: 'left' } });
            }
        });

        for (const [key, value] of sdMap) {
            sd.push({ name: key, ...value });
        }

        sd.sort((prev, next) => next.value - prev.value);

        const option = {
            tooltip: {
                trigger: 'item',
                formatter: params => {
                    if (params.dataType !== 'edge') {
                        // if (params.data.type === 'in') {
                        //     return `<div style="font-size: 10px">共输入 ${params.data.text} ${params.data.value} 例</div>`;
                        // } else {
                        //     return `<div style="font-size: 10px">${params.data.text} 共输出 ${params.data.value} 例</div>`;
                        // }
                        return `<div style="font-size: 10px">经停：${params.data.value} 例</div>`;
                    }

                    return `<div style="font-size: 10px">
                        <p>途径：${params.data.source.replace('out_', '')}</p>
                        <p>确诊城市：${params.data.target.replace('in_', '')}</p>
                        <p>病例：${params.data.value} 例</p>
                    </div>`;
                },
            },
            series: {
                type: 'sankey',
                draggable: false,
                data: sd,
                links,
                nodeWidth: 30,
                nodeGap: 15,
                top: 20,
                left: 0,
                right: 0,
                bottom: 10,
                layoutIterations: 0,
                nodeAlign: 'justify',
                focusNodeAdjacency: 'allEdges',
                lineStyle: {
                    color: 'target',
                    curveness: 0.5,
                },
                label: {
                    formatter: params => params.data.text,
                    color: 'rgba(0,0,0,0.7)',
                    fontFamily: 'PingFangSC-Regular, PingFang SC',
                    fontSize: 10,
                },
                itemStyle: {
                    borderWidth: 0,
                },
            },
        };

        this.sankey.setOption(option);
    }

    render() {
        return (
            <div className={styles.line_box}>
                <div id="echarts_sankey" className={styles.box} />
            </div>
        );
    }
}

export default errorBoundary(Sankey);
